// removed by extract-text-webpack-plugin
module.exports = {"container":"_2BJ7u2b-AvyF0OtL0G48pD"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Organizations/OrganizationInfo/Main/styles.css
// module id = 2992
// module chunks = 0